import React from 'react';
import {Box} from "@mui/material";
import Header from './Header';

interface OwnProps {
  children: React.ReactNode;
  bgColor?: string;
}

const PageWithHeader = (props: OwnProps) => {
  return (
    <Box sx={{height: '100vh', backgroundColor: props.bgColor, margin: 0, padding: 0}}>
      <Header/>
      {props.children}
    </Box>
  );
}

export default PageWithHeader;
